import { Order } from "@/models/order/order";
import { UserState } from "./modules/user/types";

export enum StoreModule {
  Global = "global/",
  User = "user/",
  Order = "order/"
}

export interface RootState {
  global: any;
  user: UserState;
  order: Order;
}
